import loadedHandler from "@/scripts/helpers/loaded.js";

const events = [
    'keydown',
    'touchstart',
    'mouseover',
];

const selector = 'template[data-async-assets]';

loadedHandler(() => {
    window['immediateScripts'] = typeof window['immediateScripts'] === 'function' ? window['immediateScripts'] : function (node) {};

    const positions = {
        head: document.head,
        body: document.body,
    };

    const lazyScripts = Object.keys(positions).reduce((scripts, position) => {
        return {
            ...scripts,
            [position]: [],
        };
    }, {}) || {};

    Object.keys(positions).forEach((position) => {
        const parent = positions[position];
        if (!parent) {
            return;
        }

        const templates = parent.querySelectorAll(selector);
        if (!templates) {
            return;
        }

        if (!templates?.length) {
            return;
        }

        templates.forEach((template) => {
            if (!template) {
                return;
            }

            const content = template.content.cloneNode(true);
            if (!content) {
                return;
            }

            const clonedNodes = Array.from(content.querySelectorAll('script, style, link')).reduce((clonedNodes, node) => {
                const tagName = node?.tagName?.toLowerCase();
                if (!tagName) {
                    return clonedNodes;
                }

                try {
                    const clonedNode = node.cloneNode(true);

                    clonedNodes.push(clonedNode);

                    node.remove();

                    return clonedNodes;
                } catch (error) {
                    console.log('Error cloning node:', error);
                }

                return clonedNodes;
            }, []);

            const nodes = [
                ...Array.from(content.children),
                ...(clonedNodes || []),
            ];

            if (!nodes) {
                return;
            }

            if (!nodes?.length) {
                return;
            }

            nodes.forEach((node) => {
                const tagName = node?.tagName?.toLowerCase();
                if (!tagName) {
                    return;
                }

                if (['body', 'head'].includes(tagName)) {
                    const innerNodes = Array.from(node.children);
                    if (!innerNodes) {
                        return;
                    }

                    if (!innerNodes?.length) {
                        return;
                    }

                    innerNodes.forEach((innerNode) => {
                        try {
                            parent.appendChild(innerNode);
                        } catch (error) {
                            console.error('Error appending script:', error);
                        }
                    });

                    node.remove();

                    return;
                }

                try {
                    const clonedNode = node.cloneNode(true);

                    if (clonedNode?.innerHTML?.includes('const themeId = window.Shopify.theme.id;')) {
                        clonedNode.innerHTML = clonedNode?.innerHTML?.replace('const themeId = window.Shopify.theme.id;', 'const themeId = window?.Shopify?.theme?.role !== "main" ? 124842934361 : window.Shopify.theme.id;');
                    }

                    if (clonedNode?.innerHTML?.includes('window.boostWidgetIntegration = {}')) {
                        clonedNode.innerHTML = clonedNode?.innerHTML?.replace('window.boostWidgetIntegration = {}', 'window.boostWidgetIntegration = window.boostWidgetIntegration || {}');
                    }

                    if (window.immediateScripts(clonedNode)) {
                        return parent.appendChild(clonedNode);
                    }

                    clonedNode.async = false;
                    clonedNode.defer = true;

                    lazyScripts[position].push(clonedNode);
                } catch(error) {
                    console.error('Error appending script:', error);
                }
            });

            template.remove();
        });

        document.body.classList.remove('immediate-scripts-loading');
        document.body.classList.add('immediate-scripts-loaded');
    });

    const loader = () => {
        Object.keys(lazyScripts).forEach((position) => {
            const parent = positions[position];
            if (!parent) {
                return;
            }

            const nodes = lazyScripts[position];
            if (!nodes) {
                return;
            }

            if (!nodes?.length) {
                return;
            }

            nodes.forEach((node) => {
                node.async = false;
                node.defer = true;

                try {
                    parent.appendChild(node);
                } catch (error) {
                    console.error('Error appending script:', error);
                }
            });
        });

        document.body.classList.remove('async-scripts-loading');
        document.body.classList.add('async-scripts-loaded');
    };

    window.addEventListener('scroll', loader, {
        once: true,
        passive: false,
    });

    events?.forEach((eventName) => {
        document.addEventListener(eventName, loader, {
            once: true,
            passive: false,
        });
    });
});
